export default "__VITE_ASSET__3f8471ef__"